"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectStatusManager = void 0;
var event_1 = require("@tencent/ark-utils/lib/event");
var login_1 = require("./login");
var connect_status_manager_interface_1 = require("./connect-status-manager.interface");
var util_1 = require("../../../util");
var collab_room_reporter_1 = __importDefault(require("../../../report/collab-room-reporter"));
var websocket_channel_1 = require("../../../websocket-channel");
var page_unload_checker_1 = __importDefault(require("./page-unload-checker"));
var ConnectStatusManager = /** @class */ (function () {
    function ConnectStatusManager(options, dependency) {
        this.options = options;
        this.dependency = dependency;
        this.onConnectEventEmitter = new event_1.Emitter();
        this.tag = 'ConnectStatusManager';
        this.connectStatus = connect_status_manager_interface_1.ConnectStatus.INIT;
        this.onConnectEvent = this.onConnectEventEmitter.event;
        this.bigCollabLogin = new login_1.BigCollabLogin(this.options, __assign(__assign({}, this.dependency), { connectStatusChange: this.connectStatusChange.bind(this) }));
        new page_unload_checker_1.default({
            disconnect: this.disconnect.bind(this),
        });
    }
    ConnectStatusManager.prototype.dispose = function () {
        this.bigCollabLogin.dispose();
        this.onConnectEventEmitter.dispose();
    };
    ConnectStatusManager.prototype.connect = function () {
        if (this.needLogin()) {
            this.bigCollabLogin.login();
            return;
        }
        util_1.ConnectionLog.warn(this.tag + " not connect. connectStatus:" + this.connectStatus);
    };
    ConnectStatusManager.prototype.isConnected = function () {
        return this.connectStatus === connect_status_manager_interface_1.ConnectStatus.CONNECTED;
    };
    ConnectStatusManager.prototype.reconnect = function (delayTime) {
        if (this.isDisconnected()) {
            util_1.ConnectionLog.info(this.tag + " can not reconnect. connectStatus: disconnected");
            return;
        }
        // WAIT_RECONNECTING 事件通知 receiver 断开链接
        this.setConnnectStatus(connect_status_manager_interface_1.ConnectStatus.WAIT_RECONNECTING);
        this.bigCollabLogin.relogin(delayTime);
    };
    ConnectStatusManager.prototype.isDisconnected = function () {
        return this.connectStatus === connect_status_manager_interface_1.ConnectStatus.DISCONNECT;
    };
    ConnectStatusManager.prototype.disconnect = function (reason) {
        var _a, _b, _c, _d;
        util_1.ConnectionLog.info(this.tag + " disconnect errorCode:" + reason.errCode + ", reason:" + reason.reason + " shutdown:" + reason.shutDown);
        this.bigCollabLogin.unlogin();
        // 关闭，不再重连
        if (reason.shutDown) {
            this.bigCollabLogin.dispose();
            this.setConnnectStatus(connect_status_manager_interface_1.ConnectStatus.DISCONNECT);
            this.dependency.disconnect(reason);
            collab_room_reporter_1.default.shutDownReport({
                module: this.options.module,
                attrName: String((_a = reason.errCode) !== null && _a !== void 0 ? _a : 0),
                status: 1 /* FAILED */,
                errorMessage: (_b = reason.reason) !== null && _b !== void 0 ? _b : websocket_channel_1.RoomUtil.getWebsocketChannelErrorMessage((_c = reason.errCode) !== null && _c !== void 0 ? _c : 0),
            });
            return;
        }
        this.bigCollabLogin.reset();
        // 先断开连接
        this.dependency.disconnect(reason);
        collab_room_reporter_1.default.reconnectReport({
            module: this.options.module,
            attrName: String((_d = reason.errCode) !== null && _d !== void 0 ? _d : 0),
            errorMessage: reason.reason,
            status: 1 /* FAILED */,
        });
        this.reconnect(reason.reconnectTime);
    };
    /**
     * 连接成功，receiver 成功后调用
     */
    ConnectStatusManager.prototype.onConnectSuccess = function () {
        if (this.isConnected()) {
            return;
        }
        this.setConnnectStatus(connect_status_manager_interface_1.ConnectStatus.CONNECTED);
        this.dependency.connected();
    };
    ConnectStatusManager.prototype.connectStatusChange = function (status, requestBaseParams, reason) {
        // 同时触发 bind get 请求
        this.setConnnectStatus(status, requestBaseParams);
        if (status === connect_status_manager_interface_1.ConnectStatus.LOGIN_FAIL) {
            this.disconnect(reason !== null && reason !== void 0 ? reason : { shutDown: false });
        }
    };
    ConnectStatusManager.prototype.needLogin = function () {
        var needLoginStatus = [connect_status_manager_interface_1.ConnectStatus.INIT, connect_status_manager_interface_1.ConnectStatus.WAIT_RECONNECTING];
        return needLoginStatus.includes(this.connectStatus);
    };
    ConnectStatusManager.prototype.setConnnectStatus = function (newStatus, serverRequestParams) {
        util_1.ConnectionLog.info(this.tag + " setConnnectStatus: oldState:" + this.connectStatus + ", newStatus = " + newStatus);
        if (newStatus !== this.connectStatus) {
            this.connectStatus = newStatus;
            this.onConnectEventEmitter.fire({ status: newStatus, serverRequestParams: serverRequestParams });
        }
    };
    return ConnectStatusManager;
}());
exports.ConnectStatusManager = ConnectStatusManager;
